import * as angular from 'angular';

import { IDispatcherService, IDispatcher, IIdentifiersActionsService } from '../';
import { Identifier, Group } from '../../models';

export interface IIdentifiersStoreService {
    deleteOne(groupGuid: string, identifierGuid: string): angular.IPromise<void>;
    duplicate(identifier: Identifier, targetGroup: Group, newsIdentifierName: string, newTagDefinitionGuid: string): angular.IPromise<Identifier>;
    add(identifier: Identifier, group: Group): angular.IPromise<Identifier>;
    update(identifier: Identifier, group: Group): angular.IPromise<Identifier>;
    updateMany(identifiers: Identifier[], group: Group): angular.IPromise<Identifier[]>;
    redorderIdentifiers(identifiers: Identifier[], group: Group): angular.IPromise<Identifier[]>;
    forceInMemoryUpdate(updated: Identifier[], isPartial?: boolean): angular.IPromise<void>;
}

export interface IIdentifiersActionDispatcherService extends IDispatcherService<IIdentifiersStoreService> { }

export class IdentifiersActionDispatcherService implements IIdentifiersActionDispatcherService {
    static serviceId = 'identifiersActionDispatcherService';

    static $inject = ['identifiersActionsService'];

    constructor(private _actionService: IIdentifiersActionsService) { }

    getDispatcher(dispatch: Function): IDispatcher<IIdentifiersStoreService> {
        return {
            dispatcher: {
                deleteOne: (g, i) => dispatch(this._actionService.deleteOne(g, i)),
                duplicate: (i, t, n, guid) => dispatch(this._actionService.duplicate(i, t, n, guid)),
                add: (i, g) => dispatch(this._actionService.add(i, g)),
                update: (i, g) => dispatch(this._actionService.updateOne(i, g)),
                updateMany: (i, g) => dispatch(this._actionService.updateMany(i, g)),
                redorderIdentifiers: (i, g) => dispatch(this._actionService.redorderIdentifiers(i, g)),
                forceInMemoryUpdate: (updated, isPartial) => dispatch(this._actionService.forceInMemoryUpdate(updated, isPartial))
            }
        };
    }
}